import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import CopyIcon from '~/assets/images/copy-icon.svg';

interface CopyWithTooltipProps {
  text: string;
  resetDelay?: number;
}
const CopyWithTooltip = ({ text, resetDelay = 1500 }: CopyWithTooltipProps) => {
  const { t } = useTranslation('common', { keyPrefix: 'copyIcon' });
  const [copyTooltip, setCopyTooltip] = useState<string>(t('copy'));

  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopyTooltip(t('copied'));
      setTimeout(() => setCopyTooltip(t('copy')), resetDelay);
    });
  };

  return (
    <Tooltip title={copyTooltip} arrow>
      <IconButton
        size="small"
        onClick={() => handleCopy(text)}
        aria-label="copy value"
        data-testid="copy-icon"
        sx={{ p: 0 }}
      >
        <Box component="img" src={CopyIcon} alt="Copy Icon" />
      </IconButton>
    </Tooltip>
  );
};

export default CopyWithTooltip;
